import { i18n } from '@/i18n'
import _ from 'lodash'
import parent from '@/store/interfaces/tableViewGeneric'

function _interface ({ masterFilters = {}, columns = [], navigate = false, selectable = false, editable = false, expandable = false, keepSelection = true, tipoEvento = 'default', customState = {}, customGetters = {}, customMutations = {}, customActions = {}, namespaced = true, getTranslateColumns = null, getTranslateMasterFilters = null, ...rest }) {
  const getMasterFilters = function () {
    const _tempFilters = typeof getTranslateMasterFilters === 'function' ? getTranslateMasterFilters() : masterFilters
    return _.merge({
      evento: { label: i18n.t('historical.evento'), value: '' },
      mensaje: { label: i18n.t('historical.info'), value: '' },
      fechaDesde: { label: i18n.t('historical.fechaDesde'), value: '', type: 'date' },
      fechaHasta: { label: i18n.t('historical.fechaHasta'), value: '', type: 'date' }
    }, _tempFilters)
  }
  const getColumns = function () {
    const _tempColumns = typeof getTranslateColumns === 'function' ? getTranslateColumns() : columns
    return _.merge([
      { field: 'idevento', width: '100px', title: i18n.t('app.id'), columnMenu: 'myTemplate', locked: false, groupable: false, hidden: true },
      { field: 'evento', width: '300px', title: i18n.t('historical.evento'), columnMenu: 'myTemplate', locked: false },
      { field: 'mensaje', width: '920px', title: i18n.t('historical.info'), columnMenu: 'myTemplate', locked: false },
      { field: 'fecha', width: '300px', title: i18n.t('historical.fechaEvento'), type: 'date', filter: 'date', format: 'numeric_datetime', cell: 'fechaTemplate', columnMenu: 'myTemplate', locked: false, extraparams: { separators: { date: '-', datetime: ' ' } } },
    ], _tempColumns)
  }
  customState = _.merge({ tipoEvento }, customState)
  customGetters = _.merge({
    getTipoEvento (state) {
      return state.tipoEvento
    }
  }, customGetters)
  return parent({ navigate, selectable, editable, expandable, keepSelection, customState, customGetters, customMutations, customActions, namespaced, getTranslateColumns: getColumns, getTranslateMasterFilters: getMasterFilters, ...rest })
}

export default _interface
